import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-distances',
  templateUrl: './distances.component.html',
  styleUrls: ['../topic-style.css','./distances.component.css']
})
export class DistancesComponent extends GeneralExerciseComponent {

  words: string[];
  pairs: string[][];
  modus: string;
  distances: number[];
  errors: number[];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.words = this.configuration.typespecifics.words;
    this.modus = this.configuration.typespecifics.modus;
    if (this.modus == "given") {
      this.pairs = [];
      for (let i = 0; i < this.words.length; i++) {
        for (let j = 0; j < i; j++) {
          this.pairs.push([this.words[i], this.words[j]]);
        }
      }
    } else {
      this.pairs = [];
    }
    this.distances = [];
    this.errors = []
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.pairs) {
        this.pairs = this.state.typespecific.pairs;
      }

      if (this.state.typespecific.distances) {
        this.distances = this.state.typespecific.distances;
      }
    }
  }

  computeState() {
    this.state.typespecific.pairs = this.pairs;
    this.state.typespecific.distances = this.distances;
  }

  checkSolution() {
    let pairs = [];
    for (let i = 0; i < this.words.length; i++) {
      for (let j = 0; j < i; j++) {
        pairs.push([this.words[i], this.words[j]]);
      }
    }
    let missingPairs = [];
    let doublePairs = [];
    let map=[];
    let i = 0;
    for (let ps of pairs) {
      let found = false;
      let j = 0;
      for (let p of this.pairs) {
        if ((ps[0] == p[0] && ps[1] == p[1]) || (ps[0] == p[1] && ps[1] == p[0])) {
          if (found) {
            doublePairs.push(p);
          } else {
            found = true;
            map[i] = j;
          }
        }
        j++;
      }
      if (!found) {
        missingPairs.push(ps);
      }
      i++;
    }
    if (missingPairs.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("missingPairs").concat(": ", missingPairs.map((v => "[".concat(v[0], ", ", v[1], "]"))).join(", ").toString()), "danger", 10000);
      //return;
    }
    if (doublePairs.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("doublePairs").concat(": ", doublePairs.map((v => "[".concat(v[0], ", ", v[1], "]"))).join(", ").toString()), "danger", 10000);
      //return;
    }
    if(doublePairs.length > 0 || missingPairs.length > 0){
      return;
    }
    let solution = pairs.map(v => this.selfcorrectingService.distance(v[0], v[1]));
    i = 0;
    this.errors = [];
    for (let i of this.createArray(pairs.length)) {
      if(this.distances[map[i]] != solution[i]){
        this.errors.push(map[i]);
      }
      i++;
    }

    if(this.errors.length > 0){
      this.messageService.addAlertWithTimeout(this.get("wrongDistances"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.state.solved = true;
      this.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    let pairs = [];
    for (let i = 0; i < this.words.length; i++) {
      for (let j = 0; j < i; j++) {
        pairs.push([this.words[i], this.words[j]]);
      }
    }
    let map=[];
    let i = 0;
    for (let ps of pairs) {
      let found = false;
      let j = 0;
      for (let p of this.pairs) {
        if ((ps[0] == p[0] && ps[1] == p[1]) || (ps[0] == p[1] && ps[1] == p[0])) {
          if (!found) {
            found = true;
            map[i] = j;
          }
        }
        j++;
      }
      i++;
    }
    let solution = pairs.map(v => this.selfcorrectingService.distance(v[0], v[1]));
    i = 0;
    let errors = [];
    for (let i of this.createArray(pairs.length)) {
      if(this.distances[map[i]] != solution[i]){
        errors.push(map[i]);
      }
      i++;
    }
    let result =  [(pairs.length - errors.length) / pairs.length, 1];
    if(this.modus == "build"){
      result = result.map(v => 2*v);
    }
    return result;
  }

  /** add a new pair of words
   * @param position - added first or second word
   * @param event - contains the word to add
   * 
   */
  addPair(position: number, event: any) {
    let elem = [];
    elem[position] = event.dragData;
    this.pairs.push(elem);
  }

  /** add a word to the given pair
   * @param pair - index of pair
   * @param position - added first or second word
   * @param event - contains word to add
   */
  addToPair(pair: number, position: number, event: any) {
    this.pairs[pair][position] = event.dragData;
  }

}
